import React, { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';

import PermissionedComponent from '~/components/Common/PermissionedComponent';
import {
  ROLE_ADMIN_USER,
  ROLE_EMPLOYEE_USER,
  ROLE_ICS_STORE_TEAM,
} from '~/consts/roles';

import useCurrentUser from '~/hooks/useCurrentUser';
import SpoofUserDialog from '../Common/SpoofUserDialog';

import { formatDateWeekDayShortMonth } from '~/services/TimeService';

const isNewDay = (idx: number, date: string, recentUsers: Array<any>) => {
  if (idx === 0) {
    return true;
  }
  const previousDate = new Date(recentUsers[idx - 1].date);
  const currentDate = new Date(date);
  return previousDate.toDateString() !== currentDate.toDateString();
};

export default function RecentUsers() {
  const savedUsers = localStorage.getItem('recentlyViewedUsers');
  const recentUsers = savedUsers ? JSON.parse(savedUsers) : [];
  const { user } = useCurrentUser();
  const [spoofUser, setSpoofUser] = useState<{ id: string; label: string; orderUuid?: string } | null>(null);

  return (
    <Box>
      <Typography variant="h4">Recently viewed users</Typography>
      <a href={`/users/${user?.id_member}`}>{user?.email}</a> (you)
      {recentUsers.map((user, idx) => (
        <Box key={user.id}>
          {isNewDay(idx, user.date, recentUsers) && (
            <Typography component="pre" variant="body2" sx={{ marginTop: 2, fontFamily: 'monospace' }}>
              {formatDateWeekDayShortMonth(user.date)}
            </Typography>
          )}
          <a href={`/users/${user.id}`}>user</a> &nbsp;{' '}
          <a href={`/purchases/section/allOrders?customer_id=${user.id}`}>orders</a> &nbsp;{' '}
          <a href={`/users/${user.id}/history`}>history</a> &nbsp;
          <PermissionedComponent requiredRoles={[ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_ICS_STORE_TEAM]}>
            <Button size="small" onClick={() => setSpoofUser({ id: user.id, label: user.label })}>
              spoof
            </Button>
          </PermissionedComponent>
          {user.label} &nbsp;
        </Box>
      ))}
      {spoofUser && (
        <SpoofUserDialog
          open={Boolean(spoofUser)}
          onClose={() => setSpoofUser(null)}
          userId={spoofUser!.id}
          userLabel={spoofUser!.label}
          orderUuid={spoofUser!.orderUuid}
        />
      )}
    </Box>
  );
}
